import { defineStore } from "pinia";
import { computed, ref, type ComputedRef, type Ref } from "vue";

export const useTicketStore = defineStore("ticket", () => {
  const ticketsByType: Ref<Tickets> = ref({
    regular: [],
    classic: [],
    miniTrip: [],
    expressTrip: [],
  });

  const tickets: ComputedRef<Ticket[]> = computed(() => [
    ...ticketsByType.value.regular,
    ...ticketsByType.value.classic,
    ...ticketsByType.value.miniTrip,
    ...ticketsByType.value.expressTrip,
  ]);

  const numberOfTickets: ComputedRef<number> = computed(() => tickets.value.length);
  const ticketsLoading: Ref<boolean> = ref(false);
  const ticketLocations: Ref<TicketLocation[]> = ref([]);

  return {
    ticketsByType,
    tickets,
    numberOfTickets,
    ticketsLoading,
    ticketLocations,
  };
});
